// src/features/landing/presentation/pages/ServicePage.jsx
import React from "react";
import { MarketProblemsSection } from "../components/MarketProblemsSection";
import { InnovationStepsSection } from "../components/InnovationStepsSection";
import { PartnershipBenefitsSection } from "../components/PartnershipBenefitsSection";
import { RbBridgeServiceSection } from "../components/RbBridgeServiceSection";
import { Footer } from "../components/Footer";

import "../styles/landing.css";

export function ServicePage() {

    return (
        <>
            <div style={{ paddingTop: '40px' }}>
                <MarketProblemsSection />
                <InnovationStepsSection />
                <PartnershipBenefitsSection />
                <RbBridgeServiceSection />
            </div>
            <Footer />
        </>
    );
}
